import React, { Component } from 'react';
import imageCompression from 'browser-image-compression';
import { setError } from '../common/toast/toast';
import './resumoEditor.css';

const PAGE_WIDTH = 794;
const PAGE_HEIGHT = 1123;

const limitar = (valor, minimo, maximo) => Math.min(Math.max(valor, minimo), maximo);

class ResumoEditor extends Component {

	constructor(props) {
		super(props);
		this.paginaRef = React.createRef();
		this.imagemInputRef = React.createRef();
		this.state = {
			layout: this.carregarLayout(props.value),
			selecionado: null,
			interacao: null
		};
	}

	componentDidMount() {
		window.addEventListener('mousemove', this.moverMouse);
		window.addEventListener('mouseup', this.finalizarInteracao);
	}

	componentWillUnmount() {
		window.removeEventListener('mousemove', this.moverMouse);
		window.removeEventListener('mouseup', this.finalizarInteracao);
	}

	carregarLayout = value => {
		let layout = value;
		if (typeof value === 'string' && value.trim()) {
			try {
				layout = JSON.parse(value);
			} catch (e) {
				layout = null;
			}
		}

		if (layout && Array.isArray(layout.elements)) {
			return { version: 1, page: { width: PAGE_WIDTH, height: PAGE_HEIGHT }, ...layout };
		}

		return {
			version: 1,
			page: { width: PAGE_WIDTH, height: PAGE_HEIGHT },
			elements: [{
				id: this.novoId(), type: 'text', x: 40, y: 88, width: 430, height: 42,
				text: 'Anexo I - Resumo', fontSize: 20, bold: true, italic: true,
				align: 'left', color: '#111111', rotation: 0, zIndex: 1
			}]
		};
	}

	novoId = () => `resumo-${Date.now()}-${Math.round(Math.random() * 100000)}`;

	codificarBase64 = valor => {
		try {
			return window.btoa(valor);
		} catch (e) {
			return '';
		}
	}

	formatarResposta = (pergunta, resposta) => {
		const valor = resposta.resposta;
		if (valor === null || valor === undefined || valor === '') return '';

		if (pergunta.id_tipo == 5) {
			const opcao = (pergunta.opcoes || []).find(item => item.id == valor);
			return opcao ? opcao.nome : String(valor);
		}
		if (pergunta.id_tipo == 6 && Array.isArray(valor)) {
			return valor.map(id => {
				const opcao = (pergunta.opcoes || []).find(item => item.id == id);
				return opcao ? opcao.nome : String(id);
			}).join(', ');
		}
		if (pergunta.id_tipo == 7) {
			return valor == 'sim' ? 'Sim' : (valor == 'nao' ? 'Não' : String(valor));
		}
		if (pergunta.id_tipo == 9) {
			return valor == 'Sim'
				? (pergunta.dependente_condicao_1 || 'Sim')
				: (valor == 'Não' ? (pergunta.dependente_condicao_2 || 'Não') : String(valor));
		}

		return Array.isArray(valor) ? valor.join(', ') : String(valor);
	}

	getRecursos = () => {
		const recursos = [];

		(this.props.listaEstrutura || []).forEach((estrutura, estruturaIndex) => {
			(estrutura.listaArea || []).forEach(area => {
				(estrutura.listaPergunta || []).filter(pergunta => pergunta.id_area == area.id).forEach(pergunta => {
					const resposta = (estrutura.listaRespostaItem || []).find(item => item.id_item == pergunta.id);
					if (!resposta) return;

					const respostaPai = (estrutura.listaRespostaItem || []).find(item => item.id_item == pergunta.id_pai);
					if (pergunta.id_pai && (!respostaPai || pergunta.pai_condicao != respostaPai.resposta)) return;

					const dadosComuns = { area: area.nome, pergunta: pergunta.descricao };
					const respostaFormatada = this.formatarResposta(pergunta, resposta);
					if (respostaFormatada) {
						recursos.push({
							...dadosComuns, tipo: 'text', id: `texto-${estruturaIndex}-${pergunta.id}`,
							titulo: pergunta.descricao, text: respostaFormatada
						});
					}
					if ((resposta.complemento_comentario || '').trim()) {
						recursos.push({
							...dadosComuns, tipo: 'text', id: `comentario-${estruturaIndex}-${pergunta.id}`,
							titulo: `${pergunta.descricao} - Comentário`, text: resposta.complemento_comentario.trim()
						});
					}

					if (pergunta.imagem) {
						recursos.push({ ...dadosComuns, tipo: 'image', id: `pergunta-${pergunta.id}`, src: `${this.props.urlBase}/${pergunta.imagem}`, legenda: pergunta.descricao });
					}
					if (resposta.complemento_foto) {
						recursos.push({ ...dadosComuns, tipo: 'image', id: `foto-${resposta.id}`, src: resposta.complemento_foto, legenda: pergunta.descricao });
					}
					(resposta.complemento_fotos || []).forEach((foto, index) => {
						if (foto) recursos.push({ ...dadosComuns, tipo: 'image', id: `fotos-${resposta.id}-${index}`, src: foto, legenda: pergunta.descricao });
					});
					(resposta.complemento_registro_fotos || []).forEach((foto, index) => {
						if (foto && foto.base64) recursos.push({
							...dadosComuns, tipo: 'image', id: `registro-${resposta.id}-${index}`,
							src: this.props.oapiUrl
								? `${this.props.oapiUrl}/imagem?id=${this.codificarBase64(`${resposta.id},${index}`)}`
								: foto.base64,
							legenda: foto.legenda || pergunta.descricao
						});
					});
				});
			});
		});

		return recursos;
	}

	proximoZIndex = () => Math.max(0, ...this.state.layout.elements.map(item => item.zIndex || 0)) + 1;

	adicionarTexto = recurso => {
		const width = 280;
		const height = 105;
		const elemento = {
			id: this.novoId(), type: 'text',
			x: (PAGE_WIDTH - width) / 2, y: (PAGE_HEIGHT - height) / 2, width, height,
			text: recurso ? recurso.text : 'Digite o texto do resumo', fontSize: 16,
			bold: false, italic: false, align: 'left', color: '#111111', rotation: 0,
			zIndex: this.proximoZIndex()
		};
		this.adicionarElemento(elemento);
	}

	adicionarImagem = recurso => {
		const imagem = new window.Image();
		imagem.onload = () => {
			const larguraNatural = imagem.naturalWidth || 300;
			const alturaNatural = imagem.naturalHeight || 220;
			const escala = Math.min(320 / larguraNatural, 240 / alturaNatural);
			const width = Math.max(1, Math.round(larguraNatural * escala));
			const height = Math.max(1, Math.round(alturaNatural * escala));
			this.inserirImagem(recurso, width, height);
		};
		imagem.onerror = () => this.inserirImagem(recurso, 300, 220);
		imagem.src = recurso.src;
	}

	inserirImagem = (recurso, width, height) => {
		this.adicionarElemento({
			id: this.novoId(), type: 'image',
			x: (PAGE_WIDTH - width) / 2, y: (PAGE_HEIGHT - height) / 2, width, height,
			src: recurso.src, alt: recurso.legenda || '', fit: 'contain', rotation: 0,
			zIndex: this.proximoZIndex()
		});
	}

	adicionarImagemComputador = async evento => {
		const input = evento.target;
		const arquivo = input.files && input.files[0];
		if (!arquivo) return;

		const formatosPermitidos = ['image/png', 'image/jpeg', 'image/webp'];
		if (!formatosPermitidos.includes(arquivo.type)) {
			setError('Selecione uma imagem PNG, JPG, JPEG ou WebP.');
			input.value = '';
			return;
		}

		let imagem = arquivo;
		try {
			imagem = await imageCompression(arquivo, {
				maxSizeMB: 1,
				maxWidthOrHeight: 2200,
				useWebWorker: true
			});
		} catch (e) {
			imagem = arquivo;
		}

		const reader = new FileReader();
		reader.onload = () => {
			this.adicionarImagem({ src: reader.result, legenda: arquivo.name });
			input.value = '';
		};
		reader.onerror = () => {
			setError('Não foi possível carregar a imagem selecionada.');
			input.value = '';
		};
		reader.readAsDataURL(imagem);
	}

	adicionarSeta = () => {
		const metade = PAGE_WIDTH / 2;
		this.adicionarElemento({
			id: this.novoId(), type: 'arrow',
			x: metade - 110, y: PAGE_HEIGHT / 2, endX: metade + 110, endY: PAGE_HEIGHT / 2,
			color: '#000000', strokeWidth: 4, zIndex: this.proximoZIndex()
		});
	}

	adicionarForma = type => {
		const circulo = type === 'circle';
		const width = circulo ? 140 : 220;
		const height = 140;
		this.adicionarElemento({
			id: this.novoId(), type,
			x: (PAGE_WIDTH - width) / 2, y: (PAGE_HEIGHT - height) / 2,
			width, height,
			filled: true, fillColor: '#fff3cd', strokeColor: '#000000',
			strokeWidth: 2, strokeStyle: 'solid', opacity: 1, rotation: 0,
			lockShape: circulo,
			zIndex: this.proximoZIndex()
		});
	}

	adicionarElemento = elemento => {
		this.setState(state => ({
			layout: { ...state.layout, elements: [...state.layout.elements, elemento] },
			selecionado: elemento.id
		}));
	}

	atualizarElemento = (id, alteracoes) => {
		this.setState(state => ({
			layout: {
				...state.layout,
				elements: state.layout.elements.map(item => item.id === id ? { ...item, ...alteracoes } : item)
			}
		}));
	}

	removerSelecionado = () => {
		if (!this.state.selecionado) return;
		this.setState(state => ({
			layout: { ...state.layout, elements: state.layout.elements.filter(item => item.id !== state.selecionado) },
			selecionado: null
		}));
	}

	moverCamada = direcao => {
		const elemento = this.getSelecionado();
		if (!elemento) return;
		this.atualizarElemento(elemento.id, { zIndex: limitar((elemento.zIndex || 0) + direcao, 0, 999) });
	}

	getSelecionado = () => this.state.layout.elements.find(item => item.id === this.state.selecionado);

	pontoPagina = evento => {
		const rect = this.paginaRef.current.getBoundingClientRect();
		return {
			x: (evento.clientX - rect.left) * PAGE_WIDTH / rect.width,
			y: (evento.clientY - rect.top) * PAGE_HEIGHT / rect.height
		};
	}

	iniciarInteracao = (evento, elemento, modo, pontoSeta) => {
		evento.preventDefault();
		evento.stopPropagation();
		this.setState({
			selecionado: elemento.id,
			interacao: {
				id: elemento.id,
				modo,
				pontoSeta,
				inicio: this.pontoPagina(evento),
				original: { ...elemento }
			}
		});
	}

	moverMouse = evento => {
		const interacao = this.state.interacao;
		if (!interacao || !this.paginaRef.current) return;
		const ponto = this.pontoPagina(evento);
		const dx = ponto.x - interacao.inicio.x;
		const dy = ponto.y - interacao.inicio.y;
		const original = interacao.original;

		if (interacao.modo === 'resize') {
			if (original.type === 'circle' && original.lockShape !== false) {
				const delta = Math.abs(dx) > Math.abs(dy) ? dx : dy;
				const tamanho = limitar(original.width + delta, 30, Math.min(PAGE_WIDTH - original.x, PAGE_HEIGHT - original.y));
				this.atualizarElemento(interacao.id, { width: tamanho, height: tamanho });
			} else {
				this.atualizarElemento(interacao.id, {
					width: limitar(original.width + dx, 30, PAGE_WIDTH - original.x),
					height: limitar(original.height + dy, 24, PAGE_HEIGHT - original.y)
				});
			}
		} else if (interacao.modo === 'arrow-point') {
			if (interacao.pontoSeta === 'start') {
				this.atualizarElemento(interacao.id, {
					x: limitar(original.x + dx, 0, PAGE_WIDTH),
					y: limitar(original.y + dy, 0, PAGE_HEIGHT)
				});
			} else {
				this.atualizarElemento(interacao.id, {
					endX: limitar(original.endX + dx, 0, PAGE_WIDTH),
					endY: limitar(original.endY + dy, 0, PAGE_HEIGHT)
				});
			}
		} else if (original.type === 'arrow') {
			this.atualizarElemento(interacao.id, {
				x: limitar(original.x + dx, 0, PAGE_WIDTH),
				y: limitar(original.y + dy, 0, PAGE_HEIGHT),
				endX: limitar(original.endX + dx, 0, PAGE_WIDTH),
				endY: limitar(original.endY + dy, 0, PAGE_HEIGHT)
			});
		} else {
			this.atualizarElemento(interacao.id, {
				x: limitar(original.x + dx, 0, PAGE_WIDTH - original.width),
				y: limitar(original.y + dy, 0, PAGE_HEIGHT - original.height)
			});
		}
	}

	finalizarInteracao = () => {
		if (this.state.interacao) this.setState({ interacao: null });
	}

	renderElemento = elemento => {
		if (elemento.type === 'arrow') return null;
		const selecionado = elemento.id === this.state.selecionado;
		const style = {
			left: elemento.x, top: elemento.y, width: elemento.width, height: elemento.height,
			zIndex: elemento.zIndex || 0,
			transform: `rotate(${elemento.rotation || 0}deg)`
		};

		return (
			<div key={elemento.id}
				className={`resumo-editor__elemento ${selecionado ? 'resumo-editor__elemento--selecionado' : ''}`}
				style={style}
				onMouseDown={evento => this.iniciarInteracao(evento, elemento, 'move')}>
				{elemento.type === 'image' ? (
					<img src={elemento.src} alt={elemento.alt || ''} style={{ objectFit: elemento.fit || 'contain' }} />
				) : elemento.type === 'text' ? (
					<div className='resumo-editor__texto' style={{
						fontSize: elemento.fontSize || 16,
						fontWeight: elemento.bold ? 'bold' : 'normal',
						fontStyle: elemento.italic ? 'italic' : 'normal',
						textAlign: elemento.align || 'left',
						color: elemento.color || '#111111'
					}}>{elemento.text}</div>
				) : (
					<div style={{
						width: '100%', height: '100%', boxSizing: 'border-box',
						borderRadius: elemento.type === 'circle' ? '50%' : 0,
						backgroundColor: elemento.filled ? (elemento.fillColor || '#ffffff') : 'transparent',
						borderColor: elemento.strokeColor || '#000000',
						borderWidth: elemento.strokeWidth || 1,
						borderStyle: elemento.strokeStyle || 'solid',
						opacity: elemento.opacity === undefined ? 1 : elemento.opacity
					}} />
				)}
				{selecionado && <span className='resumo-editor__resize'
					onMouseDown={evento => this.iniciarInteracao(evento, elemento, 'resize')} />}
			</div>
		);
	}

	renderSetas = () => (
		<svg className='resumo-editor__svg' viewBox={`0 0 ${PAGE_WIDTH} ${PAGE_HEIGHT}`}>
			<defs>
				{this.state.layout.elements.filter(item => item.type === 'arrow').map(item => (
					<marker key={item.id} id={`head-${item.id}`} markerWidth='10' markerHeight='8' refX='9' refY='4' orient='auto' markerUnits='strokeWidth'>
						<path d='M 0 0 L 10 4 L 0 8 z' fill={item.color || '#000'} />
					</marker>
				))}
			</defs>
			{this.state.layout.elements.filter(item => item.type === 'arrow').sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0)).map(item => {
				const selecionado = item.id === this.state.selecionado;
				return <g key={item.id}>
					<line x1={item.x} y1={item.y} x2={item.endX} y2={item.endY}
						stroke={item.color || '#000'} strokeWidth={item.strokeWidth || 4}
						markerEnd={`url(#head-${item.id})`} />
					<line className='resumo-editor__seta-hit' x1={item.x} y1={item.y} x2={item.endX} y2={item.endY}
						stroke='transparent' strokeWidth='18'
						onMouseDown={evento => this.iniciarInteracao(evento, item, 'move')} />
					{selecionado && <>
						<circle className='resumo-editor__seta-ponto' cx={item.x} cy={item.y} r='7' fill='#fff' stroke='#f57215' strokeWidth='3'
							onMouseDown={evento => this.iniciarInteracao(evento, item, 'arrow-point', 'start')} />
						<circle className='resumo-editor__seta-ponto' cx={item.endX} cy={item.endY} r='7' fill='#fff' stroke='#f57215' strokeWidth='3'
							onMouseDown={evento => this.iniciarInteracao(evento, item, 'arrow-point', 'end')} />
					</>}
				</g>;
			})}
		</svg>
	)

	renderPropriedades = () => {
		const elemento = this.getSelecionado();
		if (!elemento) return <div className='resumo-editor__grupo'>Selecione um elemento da página para editar.</div>;

		return <div className='resumo-editor__grupo'>
			{elemento.type === 'text' && <>
				<label>Texto</label>
				<textarea rows='7' value={elemento.text || ''} onChange={e => this.atualizarElemento(elemento.id, { text: e.target.value })} />
				<label>Tamanho da fonte</label>
				<input type='number' min='8' max='72' value={elemento.fontSize || 16}
					onChange={e => this.atualizarElemento(elemento.id, { fontSize: limitar(parseInt(e.target.value, 10) || 8, 8, 72) })} />
				<label>Cor da fonte</label>
				<input type='color' value={elemento.color || '#111111'}
					onChange={e => this.atualizarElemento(elemento.id, { color: e.target.value })} />
				<label>Alinhamento</label>
				<select value={elemento.align || 'left'} onChange={e => this.atualizarElemento(elemento.id, { align: e.target.value })}>
					<option value='left'>Esquerda</option><option value='center'>Centralizado</option>
					<option value='right'>Direita</option><option value='justify'>Justificado</option>
				</select>
				<div style={{ display: 'flex', gap: 6, marginBottom: 9 }}>
					<button type='button' className={`btn btn-sm ${elemento.bold ? 'btn-primary' : 'btn-default'}`}
						onClick={() => this.atualizarElemento(elemento.id, { bold: !elemento.bold })}>Negrito</button>
					<button type='button' className={`btn btn-sm ${elemento.italic ? 'btn-primary' : 'btn-default'}`}
						onClick={() => this.atualizarElemento(elemento.id, { italic: !elemento.italic })}>Itálico</button>
				</div>
			</>}
			{elemento.type === 'image' && <>
				<label>Ajuste da imagem</label>
				<select value={elemento.fit || 'cover'} onChange={e => this.atualizarElemento(elemento.id, { fit: e.target.value })}>
					<option value='cover'>Preencher/recortar</option><option value='contain'>Mostrar inteira</option><option value='fill'>Esticar</option>
				</select>
			</>}
			{elemento.type === 'arrow' && <>
				<label>Cor da seta</label>
				<input type='color' value={elemento.color || '#000000'}
					onChange={e => this.atualizarElemento(elemento.id, { color: e.target.value })} />
				<label>Espessura da seta</label>
				<input type='number' min='1' max='12' value={elemento.strokeWidth || 4}
					onChange={e => this.atualizarElemento(elemento.id, { strokeWidth: limitar(parseInt(e.target.value, 10) || 1, 1, 12) })} />
			</>}
			{(elemento.type === 'rect' || elemento.type === 'circle') && <>
				{elemento.type === 'circle' && <label style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
					<input type='checkbox' style={{ width: 'auto', margin: 0 }} checked={elemento.lockShape !== false}
						onChange={e => this.atualizarElemento(elemento.id, { lockShape: e.target.checked })} />
					Bloquear forma
				</label>}
				<label style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
					<input type='checkbox' style={{ width: 'auto', margin: 0 }} checked={elemento.filled !== false}
						onChange={e => this.atualizarElemento(elemento.id, { filled: e.target.checked })} />
					Usar preenchimento
				</label>
				{elemento.filled !== false && <>
					<label>Cor do preenchimento</label>
					<input type='color' value={elemento.fillColor || '#ffffff'}
						onChange={e => this.atualizarElemento(elemento.id, { fillColor: e.target.value })} />
				</>}
				<label>Cor da borda</label>
				<input type='color' value={elemento.strokeColor || '#000000'}
					onChange={e => this.atualizarElemento(elemento.id, { strokeColor: e.target.value })} />
				<label>Espessura da borda</label>
				<input type='number' min='1' max='20' value={elemento.strokeWidth === undefined ? 2 : elemento.strokeWidth}
					onChange={e => this.atualizarElemento(elemento.id, { strokeWidth: limitar(parseInt(e.target.value, 10) || 1, 1, 20) })} />
				<label>Estilo da borda</label>
				<select value={elemento.strokeStyle || 'solid'} onChange={e => this.atualizarElemento(elemento.id, { strokeStyle: e.target.value })}>
					<option value='solid'>Contínua</option>
					<option value='dashed'>Tracejada</option>
					<option value='dotted'>Pontilhada</option>
				</select>
				<label>Opacidade: {Math.round((elemento.opacity === undefined ? 1 : elemento.opacity) * 100)}%</label>
				<input type='range' min='0' max='1' step='0.05' value={elemento.opacity === undefined ? 1 : elemento.opacity}
					onChange={e => this.atualizarElemento(elemento.id, { opacity: parseFloat(e.target.value) })} />
			</>}
			{elemento.type !== 'arrow' && <>
				<label>Rotação</label>
				<input type='number' min='-180' max='180' value={elemento.rotation || 0}
					onChange={e => this.atualizarElemento(elemento.id, { rotation: limitar(parseInt(e.target.value, 10) || 0, -180, 180) })} />
			</>}
			{elemento.type !== 'arrow' && <div style={{ display: 'flex', gap: 6 }}>
				<button type='button' className='btn btn-default btn-sm' onClick={() => this.moverCamada(1)}>Para frente</button>
				<button type='button' className='btn btn-default btn-sm' onClick={() => this.moverCamada(-1)}>Para trás</button>
			</div>}
			<button type='button' className='btn btn-danger btn-sm btn-block' style={{ marginTop: 10 }} onClick={this.removerSelecionado}>Excluir elemento</button>
		</div>;
	}

	render() {
		const recursos = this.getRecursos();
		const elementosOrdenados = this.state.layout.elements.filter(item => item.type !== 'arrow')
			.sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));

		return <div className='resumo-editor'>
			<aside className='resumo-editor__painel'>
				<div className='resumo-editor__lista'>
					{recursos.map((recurso, index) => <React.Fragment key={recurso.id}>
						{(!index || recursos[index - 1].area !== recurso.area) &&
							<h5 style={{ fontSize: 12, fontWeight: 'bold', margin: '14px 2px 8px', color: '#555' }}>{recurso.area}</h5>}
						<div className='resumo-editor__recurso'>
							{recurso.tipo === 'text' ? <>
								<p><b>{recurso.titulo}</b></p>
								<p>{recurso.text}</p>
								<button type='button' className='btn btn-default btn-xs btn-block' onClick={() => this.adicionarTexto(recurso)}>Adicionar texto</button>
							</> : <>
								<img className='resumo-editor__miniatura' src={recurso.src} alt={recurso.legenda || ''} />
								<p>{recurso.legenda}</p>
								<button type='button' className='btn btn-default btn-xs btn-block' onClick={() => this.adicionarImagem(recurso)}>Adicionar imagem</button>
							</>}
						</div>
					</React.Fragment>)}
					{!recursos.length && <p>Nenhuma resposta ou imagem disponível.</p>}
				</div>
			</aside>

			<main className='resumo-editor__centro'>
				<div className='resumo-editor__barra'>
					<input ref={this.imagemInputRef} type='file' accept='image/png,image/jpeg,image/webp'
						style={{ display: 'none' }} onChange={this.adicionarImagemComputador} />
					<button type='button' className='btn btn-default btn-sm' onClick={() => this.adicionarTexto()}>+ Texto</button>
					<button type='button' className='btn btn-default btn-sm' onClick={() => this.imagemInputRef.current.click()}>+ Imagem</button>
					<button type='button' className='btn btn-default btn-sm' onClick={this.adicionarSeta}>+ Seta</button>
					<button type='button' className='btn btn-default btn-sm' onClick={() => this.adicionarForma('rect')}>+ Retângulo</button>
					<button type='button' className='btn btn-default btn-sm' onClick={() => this.adicionarForma('circle')}>+ Círculo</button>
				</div>
				<div ref={this.paginaRef} className='resumo-editor__pagina' onMouseDown={() => this.setState({ selecionado: null })}>
					{this.props.header && <img className='resumo-editor__modelo-cabecalho' src={this.props.header} alt='' />}
					{this.props.footer && <img className='resumo-editor__modelo-rodape' src={this.props.footer} alt='' />}
					<div className='resumo-editor__limite' />
					{elementosOrdenados.map(this.renderElemento)}
					{this.renderSetas()}
				</div>
			</main>

			<aside className='resumo-editor__painel resumo-editor__painel--direito'>
				<div className='resumo-editor__cabecalho'><h4>Propriedades</h4></div>
				{this.renderPropriedades()}
				<div className='resumo-editor__acoes'>
					<button type='button' className='btn btn-warning' onClick={this.props.onCancel}>Voltar</button>
					<button type='button' className='btn btn-success' onClick={() => this.props.onSave(this.state.layout)}>Salvar</button>
					<button type='button' className='btn btn-danger' onClick={() => this.props.onSave(null)}>Remover</button>
				</div>
			</aside>
		</div>;
	}
}

export default ResumoEditor;
